/* eslint-disable import/prefer-default-export */
import React from 'react';
import { getToken } from '@ctsu/loader';
import SiteInfoButton from '@ctsu/site-i-button';

const Button = ({ siteId, smallSize = false }) => (
  <SiteInfoButton
    appUrl={process.env.REACT_APP_ORIGIN}
    id={siteId}
    getToken={getToken}
    smallSize={smallSize}
    tooltip={siteId}
  />
);

export default function Siteinfobutton(props) {
  const { siteId } = props;
  if (siteId) {
    return <Button {...props} />;
  }
  return null;
}
